import {
  SystemConfigurationDto,
  PublicSystemConfigurationDto,
  PublicSystemConfigurationController,
  EnvironmentVariablesResponse,
} from '@/api';

export default {
  getSystemConfiguration: async (): Promise<SystemConfigurationDto> => {
    const response = await PublicSystemConfigurationController.getSystemConfiguration();
    return response.data!.data;
  },

  getPublicSystemConfiguration: async (): Promise<PublicSystemConfigurationDto> => {
    const response = await PublicSystemConfigurationController.getPublicSystemConfiguration();
    return response.data!.data;
  },

  getEnvironmentVariables: async (): Promise<EnvironmentVariablesResponse> => {
    const response = await PublicSystemConfigurationController.getEnvironmentVariables();
    return response.data!;
  },
};
